import React from "react";
import { motion } from "framer-motion";

const FOUNDER_IMG = "https://customer-assets.emergentagent.com/job_crash-proof-movement/artifacts/k6918818_DamienDoran-31.jpg";

const TITLES = [
  "Professional Speaker",
  "Youth Advocate",
  "Executive Director of YES",
  "Author",
  "Mentor",
  "Violence Prevention Leader",
  "Entrepreneur",
  "Curriculum Creator"
];

export default function Founder() {
  return (
    <section id="founder" data-testid="founder-section" className="relative bg-ink-800 py-28 md:py-36">
      <div className="mx-auto grid max-w-7xl gap-14 px-6 md:px-12 lg:grid-cols-12">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="relative lg:col-span-5"
        >
          <div className="relative overflow-hidden rounded-3xl border border-white/5">
            <img
              src={FOUNDER_IMG}
              alt="Damien Doran — Mr. Green Bay"
              className="aspect-[4/5] w-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-ink-900 via-ink-900/20 to-transparent" />
            <div className="absolute inset-0 mix-blend-multiply bg-gradient-to-br from-transparent via-transparent to-amber-900/20" />
            <div className="absolute bottom-6 left-6 right-6">
              <div className="text-[10px] uppercase tracking-[0.3em] text-gold">Founder</div>
              <div className="font-display text-2xl text-white md:text-3xl">Damien Doran</div>
              <div className="text-sm text-zinc-300">aka Mr. Green Bay</div>
            </div>
            <div className="absolute right-4 top-4 rounded-full border border-gold/40 bg-black/50 px-3 py-1 text-[10px] uppercase tracking-[0.25em] text-gold">
              <a href="https://www.instagram.com/mr_greenbay/" target="_blank" rel="noopener noreferrer">@mr_greenbay</a>
            </div>
          </div>
          <div className="pointer-events-none absolute -inset-6 -z-10 rounded-3xl bg-gold/10 blur-3xl" />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="lg:col-span-7"
        >
          <div className="mb-6 flex items-center gap-3 text-xs uppercase tracking-[0.3em] text-gold">
            <span className="h-px w-10 bg-gold/60" />
            Meet The Founder
          </div>
          <h2 className="font-display text-4xl font-bold leading-tight text-white md:text-5xl lg:text-6xl">
            From <span className="text-stroke-gold">brokenness</span><br />to <span className="text-gradient-gold">blueprint.</span>
          </h2>
          <p className="mt-8 text-lg leading-relaxed text-zinc-300">
            Damien Doran — known to the streets, schools, and stages as Mr. Green Bay —
            turned adversity into architecture. He's built a life out of accountability,
            emotional intelligence, and community healing, and now he's handing the
            blueprint to the next generation.
          </p>
          <p className="mt-4 text-lg leading-relaxed text-zinc-400">
            As Executive Director of <span className="text-gold-pale">YES (Youth Empowerment Summit)</span>,
            he equips youth, families, schools, and communities with the language and tools
            to choose purpose over self-destruction — every single day.
          </p>

          <div className="mt-10 flex flex-wrap gap-2">
            {TITLES.map((t) => (
              <span
                key={t}
                className="rounded-full border border-white/10 bg-ink-700/70 px-4 py-2 text-xs uppercase tracking-[0.15em] text-zinc-300 transition-colors hover:border-gold/40 hover:text-gold"
              >
                {t}
              </span>
            ))}
          </div>

          <div className="mt-12 grid grid-cols-1 gap-6 border-t border-white/5 pt-8 sm:grid-cols-3">
            {[
              { k: "Live", v: "Touring Nationwide" },
              { k: "K-12+", v: "Schools & Districts" },
              { k: "YES", v: "Executive Director" }
            ].map((s) => (
              <div key={s.v}>
                <div className="font-display text-2xl text-gold md:text-3xl">{s.k}</div>
                <div className="mt-1 text-xs uppercase tracking-[0.2em] text-zinc-500">{s.v}</div>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
